<template>
  <div class="service-package-row mt-4">
    <div v-for="(item, index) in items" :key="item.id" class="service-package-item">
      <div :class="get_header_class(index)">
        <strong class="service-package-item__title">{{ item.name }}</strong>
        <span class="service-package-item__description">
          {{ $t('pbx.service-package.card.cost', { cost: get_cost(item) }) }}
        </span>
      </div>

      <div class="service-package-item__content">
        <p>
          {{ $t('pbx.service-package.table.field.contact_count') }}:
          {{ get_service_limit(item.contact_count) }}
        </p>
        <p>
          {{ $t('pbx.service-package.table.field.contact_method_count') }}:
          {{ get_service_limit(item.contact_method_count) }}
        </p>

        <p>
          {{ $t('pbx.service-package.table.field.sip_account_with_caller_id_count') }}:
          {{ get_service_limit(item.sip_account_with_caller_id_count) }}
        </p>

        <p>
          {{ $t('pbx.service-package.table.field.ivr_count') }}:
          {{ get_service_limit(item.ivr_count) }}
        </p>
        <p :class="get_option_class(item.record)">
          {{ $t('pbx.service-package.table.field.record') }}
        </p>
        <p>{{ $t('pbx.service-package.table.field.disk_space_mb') }}: {{ item.disk_space_mb }}</p>
      </div>

      <div class="service-package-item__action-wrapper">
        <template v-if="is_current_package(item.id)">
          <span class="service-package-item__action service-package-item__action--disabled">
            {{ $t('pbx.service-package.card.connected') }}
          </span>
        </template>
        <template v-else>
          <button class="service-package-item__action" @click="connect(item)">
            {{ $t('pbx.service-package.card.connect') }}
          </button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import { PackageModalService } from '@pbx/modals/PackageModalService';
  import { toUserDate } from '@shared/helpers/date_format';

  export default {
    components: {},
    props: {
      items: {
        type: Array,
        default: () => []
      }
    },

    methods: {
      is_current_package: function (id) {
        return this.$user.pbx.package_id === id;
      },
      get_header_class: function (order) {
        return {
          'service-package-item__header': true,
          'service-package-item__header--blue': order === 1,
          'service-package-item__header--orange': order === 2
        };
      },
      get_option_class: function (is_enable) {
        return {
          'service-package-item__option': true,
          'service-package-item__option--enabled': is_enable,
          'service-package-item__option--disabled': !is_enable
        };
      },

      get_service_limit: function (val) {
        return val === -1 ? this.$t('pbx.service-package.card.unlimited') : val;
      },

      get_cost: function (item) {
        const currency_code = this.$user.currency.toLowerCase();
        const currency_key = `subscription_fee_${currency_code}`;
        return this.$numeral.currency(item[currency_key]);
      },

      connect(tariff) {
        const next_payment_format = toUserDate(this.$user.pbx.next_payment_at);
        PackageModalService.change(tariff, next_payment_format);
      }
    }
  };
</script>

<style lang="scss">
  .service-package-row {
    display: flex;
    position: relative;
    justify-content: center;

    @media screen and (max-width: 1024px) {
      flex-direction: column;
      justify-content: start;
    }
  }

  .service-package-item {
    z-index: 2;
    border-radius: 4px;
    box-shadow: 0 10px 20px 0 rgba(30, 36, 51, 0.19);
    background-color: #fff;
    display: flex;
    flex-direction: column;
    max-width: 300px;
    width: 100%;

    & + & {
      margin-left: 30px;

      @media only screen and (max-width: 1024px) {
        margin-left: 0;
      }
    }

    @media screen and (max-width: 1024px) {
      max-width: 100%;
      margin-bottom: 15px;
    }

    &__header {
      border-bottom: 1px solid #b6bbbf;
      padding: 16px 24px;
      border-radius: 4px 4px 0 0;
      background-color: $grey-dark;

      &--blue {
        background-color: $blue;
        border-color: $blue;
        color: #fff;
      }

      &--orange {
        background-color: $orange-dark;
        border-color: $orange-dark;
        color: #fff;
      }
    }

    &__title,
    &__description {
      display: inline-block;
      width: 100%;
      font-size: 14px;
    }

    &__title {
      text-transform: uppercase;
      font-weight: 700;
    }

    &__content {
      padding: 16px 24px;
      flex: 1 1 auto;
      color: $blue-grey-dark;

      p {
        margin-bottom: 0;
      }

      p + p {
        margin-top: 8px;
      }
    }

    &__option {
      padding-left: 24px;
      background-repeat: no-repeat;
      background-position: 0 1px;

      &--disabled {
        background-image: url('/img/icons/pbx/service-package/option-disabled.svg');
      }

      &--enabled {
        background-image: url('/img/icons/pbx/service-package/option-enabled.svg');
      }
    }

    &__action-wrapper {
      padding: 16px;
      padding-top: 12px;
    }

    &__action {
      background-color: #fff;
      border: solid 2px $orange-dark;
      width: 100%;
      display: inline-block;
      color: $orange-dark;
      text-align: center;
      text-transform: uppercase;
      font-size: 14px;
      font-weight: 500;
      padding: 12px 0;
      transition: all 0.3s;

      &:hover,
      &:active {
        background: $orange-dark;
        color: #fff;
        text-decoration: none;
      }

      &--disabled {
        background: $orange-dark;
        color: #fff;

        &:hover {
          cursor: not-allowed;
        }
      }
    }
  }
</style>
